import ReactDOM from "react-dom";
import { Button, Modal, ModalBody } from "reactstrap";
import styles from "./ConfirmDialog2.module.scss";
import { AiOutlineClose } from 'react-icons/ai';


function DialogBody2({ visible, toggle, activeBtnClick, bodyStyle = {}, showBackButton = true, size = "sm", showButton = true, showCloseBtn = true, ...props }) {
    return <div className={styles.ModalDialog}>
        <Modal
            toggle={toggle}
            isOpen={visible}
            size={size}
            centered
            modalClassName={styles.confirmBox}
            wrapClassName={styles.confirmBox}
            contentClassName={styles.contentBox}
            backdrop="static"
        >
            <ModalBody className={styles.body}>
                {showCloseBtn &&
                    <div className={styles.closeButton} onClick={() => toggle()}>
                        <AiOutlineClose />
                    </div>
                }
                <div style={bodyStyle}>
                    {props.children}

                    <div className={`${styles.title} ${props.error ? 'error' : ''}`}>
                        {props.title}
                    </div>
                    <div className={`${styles.subTitle} ${props.error ? 'error' : ''}`}>
                        {props.subTitle}
                    </div>
                    {showButton && <div className={styles.buttonBlock}>
                        {
                            showBackButton ? 
                            <Button style={{textDecoration: props.backUnderline ? 'underline': 'none'}} className={`${styles.button} ${props.closeBtnClassName}`} onClick={(e) => {
                                if(props.backBtnClick) {
                                    props.backBtnClick()
                                } else {
                                    toggle()
                                }
                            }} >{props.backBtn ? props.backBtn : "Cancel"}</Button> : 
                            null
                        }
                        <Button className={`${styles.button} ${styles.btnOk}`} onClick={(e) => {
                            activeBtnClick();
                        }} >{props.activeBtn ? props.activeBtn : "Yes"}</Button>
                    </div>}
                </div>

            </ModalBody>
        </Modal>
    </div>
}

const ConfirmDialog2 = (props) => props.visible ? ReactDOM.createPortal(DialogBody2(props), document.body) : null;

export default ConfirmDialog2;